import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-status-badge',
  templateUrl: './status-badge.component.html',
  styleUrls: ['./status-badge.component.scss']
})
export class StatusBadgeComponent {
  @Input() status!: string;
  private redList = ['Potential', 'Blocked', 'Processing', 'Red', 'Failed', 'Low Stock', 'Out of Stock'];
  private greenList = ['Active', 'Delivered', 'Green', 'Success', 'Published'];
  private blueList = ['Shipped', 'Draft'];

  get colorClass(): string {
    if (this.redList.includes(this.status)) {
      return 'red';
    } else if (this.greenList.includes(this.status)) {
      return 'green';
    } else if (this.blueList.includes(this.status)) {
      return 'blue';
    }
    return 'gray';
  }
}
